import { React, useEffect, useRef, useState } from "react";
import { Input } from "reactstrap";

export const  MultiSelectDropdown = ({ 
  childKey, 
  subChildren, 
  switchState, 
  getDisplayName,
  handleParentSwitchToggle,
  setSwitchState
}) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  // Get selected options
  const selectedOptions = subChildren.filter(subChild => switchState[subChild.key]);
  const selectedCount = selectedOptions.length;

  // Generate placeholder text
  const getPlaceholderText = () => {
    if (selectedCount === 0) {
      return "Select options...";
    } else if (selectedCount === 1) {
      const option = selectedOptions[0];
      return option.key.split(".").pop().replace(/([A-Z])/g, " $1").trim();
    } else if (selectedCount === subChildren.length) {
      return `All selected (${selectedCount})`;
    } else {
      return `${selectedCount} selected`;
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="position-relative" ref={dropdownRef}>
      <button
        className="form-select d-flex align-items-center justify-content-between"
        style={{ 
          width: "100%",
          textAlign: "left",
          backgroundColor: "white",
          border: "1px solid #ced4da"
        }}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
      >
        <span className={selectedCount > 0 ? "text-dark" : "text-muted"}>
          {getPlaceholderText()}
        </span>
      </button>
      
      {isOpen && (
        <div 
          className="border rounded-1 p-3 mt-1 bg-white position-absolute w-100"
          style={{ 
            zIndex: 1000,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            maxHeight: "250px",
            overflowY: "auto"
          }}
        >
          {subChildren.map((subChild, subIdx) => (
            <div key={subIdx} className="d-flex align-items-center mb-2">
              <Input
                type="checkbox"
                className="me-2"
                id={`checkbox-${subChild.key}`}
                checked={switchState[subChild.key] || false}
                onChange={() => {
                  handleParentSwitchToggle(subChild.key);
                }}
              />
              <label 
                htmlFor={`checkbox-${subChild.key}`}
                className="rv-text-color fw-normal mb-0"
                style={{ cursor: "pointer", userSelect: "none" }}
              >
                {subChild.key.split(".").pop().replace(/([A-Z])/g, " $1").trim()}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}